(function(window) { var svs = window.svs || {}; svs.modules = svs.modules || []; if(svs.modules.indexOf('/components/sport/result-boxes/views/ongoing-swipe-history.js') >= 0) return;  svs.modules.push('/components/sport/result-boxes/views/ongoing-swipe-history.js'); (function(svs, Handlebars) {
_svs=window.svs=window.svs||{};
_svs.sport=_svs.sport||{};
_svs.sport.result_boxes=_svs.sport.result_boxes||{};
_svs.sport.result_boxes.templates=_svs.sport.result_boxes.templates||{};
svs.sport.result_boxes.templates.ongoing_swipe_history = Handlebars.template({"compiler":[7,">= 4.0.0"],"main":function(container,depth0,helpers,partials,data) {
    return "<div class=\"swipe-box-title\">Trend</div>\n<div class=\"swipe-box trend-graph\">\n  <div id=\"resultGraph\" class=\"swipe-content swipe-content-history\"></div>\n</div>\n</div>\n";
},"useData":true});
Handlebars.partials['components-sport-result_boxes-ongoing_swipe_history'] = svs.sport.result_boxes.templates.ongoing_swipe_history;
})(svs, Handlebars);

 })(window);